// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// Styles
import './styles.scss';

import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';

import { Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import Fade from 'react-reveal/Fade';
import Search from 'components/commonComponents/Search';
import Loader from 'components/commonComponents/Loader';
import ImageLoader from 'components/commonComponents/ImageLoader';
import EmptyState from 'components/commonComponents/EmptyState';

const Artists = () => {
    const { currentLang, artistList } = useSelector((store) => store.commonData);
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [isLastPage, setIsLastPage] = useState(false);
    const [isLoadingPage, setLoadingPage] = useState(false);
    const [page, setPage] = useState(1);
    const [searchtext, setSearchText] = useState('')
    const [awardName, setAwardName] = useState('')
    const [festivalName, setFestivalName] = useState('')

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchArtists();
    }, [currentLang]);

    const fetchArtists = async () => {
        setLoading(true)
        const formData = new FormData();
        formData.append('language', currentLang?.id)
        if (searchParams.get('festivalId'))
            formData.append('festivalId', searchParams.get('festivalId'))
        if (searchParams.get('awardId'))
            formData.append('awardId', searchParams.get('awardId'))
        if (searchtext)
            formData.append('searchtext', btoa(unescape(encodeURIComponent(searchtext))))
        const res = await fetchData(restAPIs.artistList(formData));
        setFestivalName(res.festivalName)
        setAwardName(res.awardName)
        dispatch({
            type: 'artistList',
            value: res.items
        });
        setIsLastPage(res.isLastPage)
        setLoading(false)
    }


    const handleOnClickArtist = (item) => {
        navigate('/artist/' + item.artistId)
    }

    const handlePageClick = () => {
        let curren = page
        setPage(curren + 1);
        fetchArtistsPaginate(curren + 1)
    }


    const fetchArtistsPaginate = async (page) => {
        setLoadingPage(true)
        const formData = new FormData();
        formData.append('language', currentLang?.id)
        formData.append('page', page)
        if (searchParams.get('festivalId'))
            formData.append('festivalId', searchParams.get('festivalId'))
        if (searchParams.get('awardId'))
            formData.append('awardId', searchParams.get('awardId'))
        if (searchtext)
            formData.append('searchtext', btoa(unescape(encodeURIComponent(searchtext))))
        const res = await fetchData(restAPIs.artistList(formData));
        setIsLastPage(res.isLastPage)
        dispatch({
            type: 'artistList',
            value: artistList.concat(res.items)
        });
        setLoadingPage(false)
    }

    const handleSubmit = () => {
        fetchArtists();
    }

    const handleOnChangeSearch = (value) => {
        setSearchText(value)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSubmit();
        }
    };

    return (
        <>
            <div className='container __innerTopPad'>
                <div className='__artists_toolbar' dir={currentLang?.id === 1 ? 'rtl' : 'ltr'}>
                    <div className='__artists_toolbar_head'>
                        <h3 className='__common-head'>{t('artists')}</h3>
                        {(festivalName || awardName) &&
                            <button type='button' className='__filter_chip' onClick={() => navigate('/artists')}>
                                <span>{[festivalName, awardName].filter(Boolean).join(' · ')}</span>
                                <CloseOutlined aria-label={t('clear_filter')} />
                            </button>
                        }
                    </div>

                    <Search
                        handleOnClick={handleSubmit}
                        value={searchtext}
                        onChange={handleOnChangeSearch}
                        onKeyDown={handleKeyDown}
                        placeholder={t('search')}
                    />
                </div>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        {isLoading ?
                            <Loader />
                            :
                            <>
                                <div className='__artist_grid_list'>
                                    {

                                        artistList && artistList?.map((item, idx) => {
                                            return (
                                                <Fade bottom cascade>
                                                    <div className='__artist_single' key={idx} onClick={() => handleOnClickArtist(item)}>
                                                        <div className='__artist_single_media'>
                                                            <ImageLoader src={item.picture} alt={item.title} />
                                                            <div className='__artist_single_scrim' />
                                                            <div className='__artist_single_info'>
                                                                <h2>{item.title}</h2>
                                                                <p>{item.dateOfBirth}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Fade>
                                            )
                                        })}
                                </div>
                                {!isLoading && artistList?.length === 0 && <EmptyState message={t('no_results_found')} />}
                                {isLoadingPage ? <Spin className='__spin_color' size="large" tip="Loading" /> : ''}</>
                        }
                    </div>
                    {isLoading ? '' :
                        <div className='__pagination' style={{ justifyContent: 'center' }}>
                            {isLastPage ? '' : <button onClick={handlePageClick}>{t('more')} </button>}
                        </div>
                    }
                </div>
            </div >
        </>
    );
};


export default Artists;
